module.exports = __webpack_public_path__ + "static/media/original-budget.29142f8a.svg";